import { AlertTriangle, CheckCircle2, ChevronRight } from 'lucide-react';
import { useAlunosEmAtencao } from '../../api/hooks/useObservacoes';
import type { ClassificacaoRisco } from '../../api/hooks/useObservacoes';

const RISCO: Record<ClassificacaoRisco, { label: string; color: string; bg: string }> = {
  BEM:         { label: 'Bem', color: '#22c55e', bg: 'rgba(34,197,94,0.1)' },
  ATENCAO:     { label: 'Atencao', color: '#f59e0b', bg: 'rgba(245,158,11,0.1)' },
  PREOCUPANTE: { label: 'Preocupante', color: '#f97316', bg: 'rgba(249,115,22,0.1)' },
  CRITICO:     { label: 'Critico', color: '#ef4444', bg: 'rgba(239,68,68,0.1)' },
};

interface Props {
  professorId: string;
  onClickAluno?: (id: string) => void;
}

export function MobileAlunosAtencao({ professorId, onClickAluno }: Props) {
  const { data: alunos = [], isLoading } = useAlunosEmAtencao(professorId);

  // Nao mostrar o card se nao tem alunos em risco
  if (!isLoading && alunos.length === 0) return null;

  return (
    <div className="mobile-atencao-list">
      <div className="mobile-atencao-header">
        <AlertTriangle size={14} style={{ color: '#f59e0b' }} />
        <span style={{ fontSize: '0.72rem', fontWeight: 700, flex: 1 }}>Alunos em Atencao</span>
        {alunos.length > 0 && (
          <span style={{ fontSize: '0.6rem', fontWeight: 700, padding: '2px 8px', borderRadius: 10, background: 'rgba(239,68,68,0.1)', color: '#ef4444' }}>
            {alunos.length}
          </span>
        )}
      </div>

      {isLoading && (
        <div style={{ padding: 20, textAlign: 'center', fontSize: '0.72rem', color: 'var(--text-muted)' }}>
          Carregando...
        </div>
      )}

      {!isLoading && alunos.map(a => {
        const r = RISCO[a.classificacao] || RISCO.ATENCAO;
        return (
          <div key={a.alunoId} className="mobile-atencao-row" onClick={() => onClickAluno?.(a.alunoId)}>
            <div className="mobile-atencao-score" style={{ background: r.bg, color: r.color }}>
              {a.score}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-main)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {a.nome}
              </div>
              <div style={{ display: 'flex', gap: 8, fontSize: '0.6rem', color: 'var(--text-muted)', marginTop: 1 }}>
                <span>{a.turma}</span>
                <span>Freq: {a.frequencia.toFixed(0)}%</span>
                <span>Media: {a.mediaGeral.toFixed(1)}</span>
              </div>
            </div>
            <span style={{ fontSize: '0.55rem', fontWeight: 700, padding: '2px 6px', borderRadius: 6, background: r.bg, color: r.color, textTransform: 'uppercase', flexShrink: 0 }}>
              {r.label}
            </span>
            <ChevronRight size={14} style={{ color: 'var(--text-muted)', flexShrink: 0, opacity: 0.4 }} />
          </div>
        );
      })}
    </div>
  );
}
